"use client";

import { useQuery } from "@tanstack/react-query";
import { forwardRef, useMemo } from "react";
import { BlokParameters } from "../../blokSetup/blok-component-types";
import { getBlokComponent } from "../../blokSetup/bloks";
import { StoryblokComponentProps } from "../StoryblokComponent";
const ClientComponentWithFetcher = forwardRef<
  HTMLElement,
  StoryblokComponentProps<BlokParameters> & {
    fetcher: (arg0: any) => Promise<any>;
    queryKeyFn: (arg0: any) => any;
  }
>(({ blok, preview, sidebyside, fetcher, queryKeyFn, ...restProps }, ref) => {
  const Component = getBlokComponent(blok.component)?.blok;

  const key = useMemo(() => {
    const key = queryKeyFn(blok);
    if (!key) {
      console.warn(
        blok.component,
        "queryKeyFn has returned undefined, falling back to using _uid as key.",
        "May result in stale data"
      );
      return [blok?._uid];
    }
    return Array.isArray(key) ? key : [key];
  }, [blok, queryKeyFn]);

  const { data } = useQuery({
    queryKey: ["blok", ...key],

    queryFn: () => fetcher(blok)
  });

  if (!Component) {
    const errorMessage = `Component: "${blok.component}" not found`;
    return <div>{errorMessage}</div>;
  }

  return (
    <Component
      ref={ref}
      blok={blok}
      {...restProps}
      sidebyside={sidebyside}
      data={data}
      preview={preview}
    />
  );
});
ClientComponentWithFetcher.displayName = "StoryblokClientComponentWithFetcher";

export default ClientComponentWithFetcher;
